import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { Venue } from "../../../core/_models/venue.model";
import { VenueService } from "../../../core/_services/venue.service";
import { NotificationService } from "../../../core/_services/notification.service";

@Component({
  selector: 'app-venue',
  templateUrl: './venue.component.html',
  styleUrls: ['./venue.component.sass']
})
export class VenueComponent implements OnInit {

  public model: Venue = null;
  public modelToBeSaved: Venue = null;
  public isEditing = false;
  public isDeleting = false;

  private _modelUuid: string = null;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _venueService: VenueService,
    private _router: Router,
    private _notificationService: NotificationService
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      if(params['uuid']) {
        this.getModel(params['uuid']);
      } else {
        this.model = null;
        this._modelUuid = null;
        this.changeMode('edit');
      }
    });
  }

  getModel(modelUuid: string) {
    this._venueService.get(modelUuid)
      .subscribe((model) => {
        this.model = model;
        this._modelUuid = model.uuid;
        this.changeMode('view');
      }, () => {
        this._router.navigate(['/panel/not-found']);
      });
  }

  changeMode(mode: 'view' | 'edit') {
    if (mode == 'view') {
      if (!this._modelUuid) {
        this._router.navigate(['/panel/venues']);
      }
      this.isEditing = false;
    }
    if (mode == 'edit') {
      this.isEditing = true;
    }
  }

  saveModel() {
    if (this.modelToBeSaved) {
      if (this.modelToBeSaved.uuid) {
        this._venueService.update(this.modelToBeSaved.uuid, this.modelToBeSaved).subscribe((model) => {
          this.getModel(model.uuid);
          this.changeMode('view');
          this._notificationService.success("Saved");
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      } else {
        this._venueService.create(this.modelToBeSaved).subscribe((model) => {
          this._notificationService.success("Saved");
          this._router.navigate(['/panel/venue', {uuid: model.uuid}]);
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      }
    }
  }

  deleteModel() {
    this.isDeleting = true;
  }

  onModelDeleted(shouldDelete: boolean = false) {
    this.isDeleting = false;
    if (shouldDelete) {
      if (this._modelUuid) {
        this._venueService.delete(this._modelUuid).subscribe(() => {
          this._notificationService.success("Deleted");
          this._router.navigate(['/panel/venues']);
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      } else {
        this._router.navigate(['/panel/venues']);
      }
    }
  }

  onModelChanged(modelToBeSaved: Venue) {
    if (modelToBeSaved) {
      this.modelToBeSaved = modelToBeSaved;
      this.modelToBeSaved.uuid = this._modelUuid;
    } else {
      this.modelToBeSaved = null;
    }

  }

}
